import classNames from 'classnames';

export default function Box({ title, content, color = 'gray', unit }) {
  return (
    <div className="flex-col w-2/12 text-center">
      <div className="text-gray">{title}</div>
      <div
        className={classNames('font-bold text-lg sm:text-2xl whitespace-nowrap', {
          'text-red': color === 'red',
          'text-green': color === 'green',
          'text-gray-dark': color === 'gray',
        })}
      >
        {content}
        {unit && <span className="text-gray text-xs xs:text-base font-normal xs:pl-2">{unit}</span>}
      </div>
    </div>
  );
}
